import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import logoWhite from "@/assets/logo-white.webp";

export function LandingHeader({
  ctaLabel = "Check My AI Visibility — Free",
  ctaHref = "#check",
  onClick,
  showCta = true,
}: {
  ctaLabel?: string;
  ctaHref?: string;
  onClick?: () => void;
  showCta?: boolean;
}) {
  const classes =
    "btn-gradient hover:-translate-y-px hover:brightness-110 transition-all rounded-full px-4 py-2 text-sm font-medium inline-flex items-center gap-2 whitespace-nowrap";
  return (
    <header className="sticky top-0 z-50 glass-nav">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" aria-label="Axy.digital home">
          <img src={logoWhite} alt="Axy.digital" width={225} height={91} className="h-7 w-auto" />
        </Link>
        {!showCta ? null : onClick ? (
          <button type="button" onClick={onClick} className={classes}>
            {ctaLabel} <ArrowRight className="size-4" />
          </button>
        ) : (
          <a href={ctaHref} className={classes}>
            {ctaLabel} <ArrowRight className="size-4" />
          </a>
        )}
      </div>
    </header>
  );
}
